import { styled } from '@mui/material';
import BluLoader from '../../common/Loader';

const StyledGridOverlay = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  backgroundColor: 'transparent',
}));

export const CustomGridLoader = () => {
  return (
    <StyledGridOverlay>
      <BluLoader open />
    </StyledGridOverlay>
  );
};
